import { AssetDto } from '@nusign/picflow-backend-types';

const dateRegex = /[0-9]{2,4}[-_/. ][0-9]{1,2}[-_/. ][0-9]{1,4}/;
const numbersRegex = /[0-9]{1,}/;

const calcCommonString = (assets: AssetDto[]): string => {
  if (!assets.length) return '';
  return findCommonInternal(assets, assets[0].version_data.asset_name);
};

const shortenString = (string: string) => {
  const separators = ['_', '-', ' '];
  const index = separators.reduce((acc, sep) => {
    const i = string.lastIndexOf(sep);
    return i > acc ? i : acc;
  }, -1);

  if (index === -1) return string.substring(0, string.length - 1);

  return string.substring(0, index);
};

/**
 * Recursive function to find the common string in the asset names.
 */
const findCommonInternal = (assets: AssetDto[], string: string) => {
  if (!string) return string; // Empty string, this happens when all assets don't have a common starting strin

  if (string.match(dateRegex)) {
    // If the string is a valid date, we don't want to cut off the date or year
    // But we first need to check if all assets have a date in the name
    const allAssetsNamesHaveDateInSamePlace = assets.every(i =>
      i.version_data.asset_name.substring(0, string.length).match(dateRegex)
    );
    if (allAssetsNamesHaveDateInSamePlace) return '';
  }

  const stringDoesntExistsInAllAssetNames = assets.some(
    i => i.version_data.asset_name.substring(0, string.length) !== string
  );

  const lastCharacterIsNumber = string.substr(-1, 1).match(numbersRegex);

  if (stringDoesntExistsInAllAssetNames || lastCharacterIsNumber) {
    // If the string doesn't exist in all of the asset names, we remove the last character and try again
    return findCommonInternal(assets, shortenString(string));
  }
  // We found a string that exists in all of the asset names and doesn't end with a number

  const stringmatchesAnAssetNameWithoutExtension = assets.some(i => i.version_data.asset_name.split('.')[0] === string);
  if (stringmatchesAnAssetNameWithoutExtension) {
    return findCommonInternal(assets, shortenString(string));
  }

  return string;
};

export const simplifiedAssetNames = (assets: AssetDto[]) => {
  const names = {};
  const commonString = calcCommonString(assets);
  assets.forEach(img => {
    let name = img.version_data.asset_name;
    const array = name.split('.');
    array.pop();
    name = array.join('.');
    name = name.split(commonString).join('');
    names[img.id] = name;
  });
  return names;
};
